import React from "react";
import ReactDOM from "react-dom";
import SSOAccountSearch from "./SSOAccountSearch.jsx";

export function initSSOAccountSearch() {
  document.querySelectorAll(".js-sso-account-search").forEach((mount, i) => {
    const businessUnitsArray = window.businessUnits
      ? JSON.parse(window.businessUnits.replace(/'/g, '"'))
      : [];
    ReactDOM.render(
      <SSOAccountSearch businessUnits={businessUnitsArray} />,
      mount,
    );
  });
}
